interface TwitterIconProps {
    color?: string;
    className?: string;
}

function TwitterIcon({ color = 'currentColor', className = null }: TwitterIconProps) {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="22px"
            height="22px"
            viewBox="0 0 22 22"
            xmlSpace="preserve"
            className={className || undefined}
        >
            <path
                fill={color}
                d="M12.9,9.5L20.4,1h-1.8l-6.5,7.4L7,1H1l7.8,11.1L1,21h1.8l6.8-7.8L15,21h6 M3.4,2.3h2.7l12.5,17.5h-2.7"
            />
        </svg>
    );
}

export default TwitterIcon;
